import React, { useContext } from 'react';

import { ReactComponent as CircleCheck } from '../../../assets/icons/CircleCheck.svg';
import Context from '../../../store/context';
import Button from '../../Buttons/Button/Button';

import classes from './SuccessIntegration.module.scss';

const SuccessIntegration = () => {
  const {
    modal: { hideModal }
  } = useContext(Context);
  return (
    <div className={classes.content}>
      <CircleCheck className={classes.icon} />
      <span className={`bold-18 ${classes.list}`}>¡Listo!</span>
      <span className={`semibold-16 ${classes.title}`}>La sincronización se activo de manera exitosa</span>
      <span className={`medium-16 ${classes.description}`}>
        Recuerda que la sincronización dura activa una hora y cada 24 horas se te enviará un código para actualizarla.{' '}
      </span>
      <div className={classes.button}>
        <Button onClick={hideModal}>Entendido</Button>
      </div>
    </div>
  );
};

export default SuccessIntegration;
